import BootstrapIconPicker from '../BootstrapIconPicker/BootstrapIconPicker';
import { pWarn } from '_/helpers/logger';
import { mapGetters } from 'vuex';

export default {
    /**
     * Set the components
     *
     * @return  {object}
     */
    components: {
        BootstrapIconPicker,
    },

    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        defaultValue: {
            type: [Boolean, String],
        },
        disabled: {
            type: Boolean,
        },
        required: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        name: {
            required: true,
            type: String,
        },
        placeholder: {
            type: String,
        },
        refreshFields: {
            type: Number,
        },
        type: {
            default: 'text',
            type: String,
        },
        value: {
            default: null,
            type: [String, Boolean, Number],
        },
    },

    /**
     * Set the computed properties
     *
     * @type  {object}
     */
    computed: {
        ...mapGetters({
            admin: 'admin/admin',
        }),
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.$nextTick(() => {
            this.setDefaultValueIfRequired();
        });
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        /**
         * Emmits a change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onChange: function ({ id, value }) {
            this.$emit('change', {
                id,
                name: this.name,
                value,
            });
        },

        /**
         * Sets a component value to defaultValue, if required
         *
         * @return  {void}
         */
        setDefaultValueIfRequired() {
            if (this.defaultValue && this.admin.editorMode === 'create') {
                this.$emit('change', {
                    id: this.id,
                    name: this.name,
                    value: this.defaultValue,
                });
            }
        },
    },

    /**
     * Define the watched properties
     *
     * @type  {Object}
     */
    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                pWarn('Watched property fired.', `InputTag.${this.name}`, 'refreshFields', newEntry, oldEntry, this);

                this.setDefaultValueIfRequired();

                this.$forceUpdate();

                $(this.$el).val(this.value);
            }
        },
    },
};
